import { useGlobalState } from '../../../state/persistence';

const useGetHeaderLogo = (): string | undefined => {
  const { appStore } = useGlobalState();
  const headerPartner = appStore.partner ? appStore.partner.slug : appStore.ref;
  return headerPartner ? `https://static.mineko.de/partner-header-logo/${headerPartner}.png` : undefined;
};

export default useGetHeaderLogo;
